document.addEventListener("DOMContentLoaded", () => {
    const logo = document.querySelector(".js-cb-logo img");
    if (!logo) return;

    let currentRotation = 0; 
    let targetRotation = 0;

    function animate() {
    currentRotation += (targetRotation - currentRotation) * 0.05;
    logo.style.transform = `rotate(${currentRotation}deg)`;
    requestAnimationFrame(animate);
    }

    window.addEventListener("scroll", () => {
    const rect = logo.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const elementCenter = rect.top + rect.height / 2;
    const screenCenter = viewportHeight / 2;
    const offset = elementCenter - screenCenter;

    const maxOffset = viewportHeight / 2; 
    let factor = offset / maxOffset; 

    if (factor > 1) factor = 1;
    if (factor < -1) factor = -1;

    targetRotation = factor * -60;
    });

    animate();
});